import React from "react";
import check_Icon from "../../../../src/assets/check_Icon.svg";
import cross_Icon from "../../../../src/assets/cross_Icon.svg";
import link_send_circle_icon from "../../../../src/assets/link_send_circle_icon.svg";
import link_send_icon from "../../../../src/assets/link_send_icon.svg";
import "./emailStatus.scss";

// Email Verified Component
export const EmailVerified = () => {
  return (
    <div className="email-status-verified">
      <img src={check_Icon} alt="Verified" className="icon" />
      <span className="email-verify-text">Email Verified</span>
    </div>
  );
};

// Email Not Verified Component
export const EmailNotVerified = () => {
  return (
    <div className="email-status-not-verified">
      <img src={cross_Icon} alt="Not Verified" className="icon" />
      <span className="email-not-verify-text">Email Not Verified</span>
    </div>
  );
};

export const VerifyEmailButton = ({ onClick }) => {
  return (
    <button className="verify-email-button" onClick={onClick}>
      <img
        src={link_send_circle_icon}
        alt="Verify button"
        className="Verify-button-icon"
      />
      Verify Email
    </button>
  );
};

export const VerificationSentButton = ({ onClick }) => {
  return (
    <button className="verification-sent-button" onClick={onClick}>
      <img
        src={link_send_icon}
        alt="Info"
        className="verification-sent-button-icon"
      />
      Verification Link Sent !
    </button>
  );
};
